import React from "react";
import "./styles/PlanCard.css";
import { CustomBtn } from "./BasicComponents";
import {formatStoreCurrency, isIndia} from '../assets/currency'
import { useTranslation } from "react-i18next";
import "../localisation/index"

const PlanCard = ({ plan, active, popular, btnText, setPlan, amountPaid }) => {
  const {t} = useTranslation()
  return (
    <div className={`plan-card ${active ? "card-shadow" : ""}`}>
      {/* popular plan */}
      {plan?.plan_name.toLowerCase() === "pro" && (
        <div className="popular-banner">
          <img src={require("../assets/icons/pngs/cardcap.png")} alt="" />
          <div className="text">{t("plancard.mostPopular")}</div>
        </div>
      )}

      <div className="plan-card-title">{plan?.interval==='ANNUAL' ? plan?.plan_name.split(" ").slice(0,-1).join(" ") : plan?.plan_name}</div>
      <div className="plan-card-price">
        {formatStoreCurrency((amountPaid ? amountPaid : plan?.price || 0), plan?.currency)}
        <span>{plan?.interval==='ANNUAL' ? '/Annual' : '/Month' }</span>
        {
          plan?.currency==='INR' && <div className="plan-card-gst">{t("plancard.gst")}</div>
        }
      </div>

      <div className="bar"></div>

      <div className="plan-card-subtitle">
      {t("plancard.create")}
      </div>
      <div className="plan-card-value">
        {/* <img src={RoundedTick} alt="" /> */}
        {t("plancard.upto")} {formatStoreCurrency(plan?.plan_limit || 0, plan?.currency)}
      </div>

      <div className="bar"></div>

      <div className="plan-card-subtitle">
        {/* Monthly Usage Fees (Charge beyond limits) */}
        {t("plancard.usage")}
      </div>
      <div className="plan-card-value">
        {/* <img src={RoundedTick} alt="" /> */}
        {plan?.usage_charge || 0}% {t("plancard.insuance")}
        {/* As of (%) value of Issuance - {plan?.usage_charge}% */}
      </div>

      {/* btn  */}
      {btnText !== "" ? (
        <div className="plan-card-btn">
          <CustomBtn active={active} onClick={() => setPlan(plan)}>
            {btnText}
          </CustomBtn>
        </div>
      ) : (
        ""
      )}

      <div className="plan-card-maxlimit">* {t("plancard.maxIssuance")} {formatStoreCurrency(plan?.usage_limit || 0, plan?.currency)}</div>
    </div>
  );
};

export default PlanCard;
